import { push, LOCATION_CHANGE } from 'connected-react-router';
import { defaultRowsPrPage, defaultUserFilter, defaultUserSort } from '../../common/constants';
import { setAppVersion, VERSION_EXPIRED } from '../../youwell-common/fetchUtils';

const SET_PATH = 'PAGESETTINGS/SET_PATH';
const SET_VERSION = 'PAGESETTINGS/SET_VERSION';
const SET_CONFIG = 'PAGESETTINGS/SET_CONFIG';
const SHOW_INTROTOUR = 'PAGESETTINGS/SHOW_INTROTOUR';

const SET_USER_PAGE = 'PAGESETTINGS/SET_USER_PAGE';
const SET_USER_ROWS_PER_PAGE = 'PAGESETTINGS/SET_USER_ROWS_PER_PAGE';
const SET_USER_SORT = 'PAGESETTINGS/SET_USER_SORT';
const SET_USER_FILTER = 'PAGESETTINGS/SET_USER_FILTER';

export const actionCreators = {
    setAppConfig: appConfig => (dispatch) => {
        dispatch({ type: SET_CONFIG, appConfig });
    },

    setPath: path => (dispatch) => {
        const pathWithSlash = path && path[0] === '/' ? path : `/${path}`;
        dispatch({ type: SET_PATH, path: pathWithSlash });
    },

    setVersion: version => (dispatch) => {
        setAppVersion(version);
        dispatch({ type: SET_VERSION, version });
    },

    redirect: path => (dispatch) => {
        dispatch(push(path));
    },
    showIntroTour: (show = true) => (dispatch) => {
        dispatch({ type: SHOW_INTROTOUR, payload: show });
    },
    setUserPage: page => (dispatch) => {
        dispatch({ type: SET_USER_PAGE, page });
    },

    setUserRowsPerPage: rowCount => (dispatch) => {
        dispatch({ type: SET_USER_ROWS_PER_PAGE, rowCount });
    },

    setUserSorting: sorting => (dispatch) => {
        dispatch({ type: SET_USER_SORT, sorting });
    },

    setUserFilter: filter => (dispatch) => {
        dispatch({ type: SET_USER_FILTER, filter });
    },

};

const initialState = {
    pathname: '',
    version: '',
    newAvailableVersion: '',
    appConfig: {},
    versionExpired: false,
    showIntroTour: false,
    userPage: 0,
    userRowsPerPage: defaultRowsPrPage,
    userSorting: defaultUserSort,
    userFilter: defaultUserFilter,
};

export const reducer = (state, action) => {
    switch (action.type) {
    case SET_CONFIG: {
        return {
            ...state,
            appConfig: action.appConfig || {},
        };
    }
    case SET_PATH: {
        return {
            ...state,
            pathname: action.path,
        };
    }
    case SET_VERSION: {
        return {
            ...state,
            version: action.version,
        };
    }
    case LOCATION_CHANGE: {
        return {
            ...state,
            pathname: action.payload.pathname,
        };
    }
    case VERSION_EXPIRED: {
        return {
            ...state,
            versionExpired: true,
            previous: action.previous,
            newAvailableVersion: action.newAvailableVersion,
        };
    }
    case SHOW_INTROTOUR: {
        return {
            ...state,
            showIntroTour: action.payload,
        };
    }
    case SET_USER_PAGE: {
        return {
            ...state,
            userPage: action.page,
        };
    }
    case SET_USER_ROWS_PER_PAGE: {
        return {
            ...state,
            userRowsPerPage: action.rowCount,
        };
    }
    case SET_USER_SORT: {
        return {
            ...state,
            userPage: 0,
            userRowsPerPage: defaultRowsPrPage,
            userSorting: action.sorting,
        };
    }
    case SET_USER_FILTER: {
        return {
            ...state,
            userPage: 0,
            userRowsPerPage: defaultRowsPrPage,
            userFilter: action.filter,
        };
    }
    default: {
        return state || initialState;
    }
    }
};
